import * as React from 'react';
import styled from 'styled-components';
import { MinusIcon, PlusIcon } from './RepAprTerm';
import { formatCurrency } from '@zopauk/libs-formats';
import { InputRange, TextField, Alert } from '@zopauk/react-components';
import { loanSettings } from '@/components/LoanForm/Calculator/constants';

type RepAprAmountProps = {
  onChange: (amount: number) => void;
  value: number;
};

const StyledLabel = styled.label`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledContainer = styled.div`
  margin-bottom: 40px;
`;

export const RepAprAmount = ({ onChange, value }: RepAprAmountProps) => {
  const [showAlert, setShowAlert] = React.useState(false);
  const loanAmountStep = 500;

  const maybeShowAlert = (value: string | number) => {
    const amount = typeof value === 'number' ? value : Number(value.replace(/\D/g, ''));
    if (amount > loanSettings.max.amount || amount < loanSettings.min.amount) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
  };

  return (
    <>
      <StyledContainer>
        <TextField
          onChange={(e) => {
            maybeShowAlert(e.target.value);
            onChange(Number(e.target.value.replace(/\D/g, '')));
          }}
          onBlur={(e) => {
            onChange(Number(e.target.value.replace(/\D/g, '')));
          }}
          title={`Input a number between ${loanSettings.min.amount} and ${loanSettings.max.amount}`}
          data-automation="ZA.loan-amount-input"
          value={formatCurrency(value)}
          className="mb-4 text-lg"
          label="Loan amount"
          inputMode="numeric"
          name="loan-amount"
          pattern="[0-9]+"
        />
        {showAlert ? (
          <Alert severity="brand" className="my-2">
            Please enter an amount between {formatCurrency(loanSettings.min.amount)} and{' '}
            {formatCurrency(loanSettings.max.amount)}
          </Alert>
        ) : null}
        <StyledLabel htmlFor="amount-range">Range of loan amounts in pounds</StyledLabel>

        <InputRange
          onChange={(e) => {
            maybeShowAlert(e);
            onChange(e);
          }}
          data-automation="ZA.loan-amount-slider"
          customMinusIcon={<MinusIcon />}
          min={loanSettings.min.amount}
          max={loanSettings.max.amount}
          customPlusIcon={<PlusIcon />}
          step={loanAmountStep}
          id="amount-range"
          className="mx-3"
          value={value}
          controls
        />
      </StyledContainer>
    </>
  );
};
